import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'

import { getFormattedTime, getHoursMinutes } from 'helpers/datetime'
import { MAX_SET_TIMEOUT_VALUE } from 'constants'

export default class Timer extends React.Component{
    static propTypes = {
        startTime: PropTypes.instanceOf(moment),
        endTime: PropTypes.instanceOf(moment),
        onExpire: PropTypes.func,
        onExpireDelay: PropTypes.number,
        shortFormat: PropTypes.bool,
        hideSeconds: PropTypes.bool,
    }
    componentWillMount() {
        this.update()
    }
    update() {
        this.clearTimeouts()
        if (!this.props.endTime && !this.props.startTime) return

        let milliseconds
        if (this.props.endTime) {
            milliseconds = Math.max(this.props.endTime.diff(moment()), 0)

            if (this.props.onExpire && milliseconds === 0) {
                if (this.props.onExpireDelay) {
                    this.onExpireTimeoutId = setTimeout(
                        this.props.onExpire,
                        Math.min(this.props.onExpireDelay, MAX_SET_TIMEOUT_VALUE)
                    )
                } else {
                    this.props.onExpire()
                }
            }
        } else {
            milliseconds = moment().diff(this.props.startTime)
        }

        this.timeoutId = setTimeout(this.update.bind(this), 1000)

        this.setState({
            milliseconds,
        })
    }
    componentWillUnmount() {
        this.clearTimeouts()
    }
    clearTimeouts() {
        if (this.timeoutId) clearTimeout(this.timeoutId)
        if (this.onExpireTimeoutId) clearTimeout(this.onExpireTimeoutId)
    }
    getTimeLeftLabel(milliseconds) {
        if (this.props.shortFormat) return moment(milliseconds).format('mm:ss')
        return this.props.hideSeconds ?
            getHoursMinutes(milliseconds) :
            getFormattedTime(milliseconds, true)
    }
    render() {
        if (!this.props.endTime && !this.props.startTime) return null

        const formattedTime = this.getTimeLeftLabel(this.state.milliseconds)
        return (
            <span>{formattedTime}</span>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Timer/Timer.jsx